// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1-vWi","title":"Images45_title__3QJah","images":"Images45_images__1e5Ux"};